import { getRouteApi } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history/src/components/HistoryTable'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSection } from 'ui/components'
import { AnnualReviewDetails } from '~bank-annual-review/types/AnnualReviewDetails'

const routeApi = getRouteApi('/_app/annual-review/detail/$companyId/$id')

export const History = () => {
  const { history, historyTotalCount } = routeApi.useLoaderData() as AnnualReviewDetails
  const search = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  return (
    <PageSection title="Annual Review History" anchor="history">
      <Layer rounded shadowed stretch>
        <HistoryTable
          dataQa={TableDataQa.BP_ANNUAL_REVIEW_DETAILS_HISTORY}
          items={history}
          pagination={{
            page: search.historyPage,
            size: search.historySize,
            onChange: (historyPage, historySize) =>
              navigate({
                to: '/annual-review/detail/$companyId/$id',
                resetScroll: false,
                replace: true,
                search: { historyPage, historySize }
              }),
            total: historyTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
